import axios from "axios";

const requestJoinFuneralApi = parameter => {
  let formData = new FormData();

  formData.append("fileList", parameter.files[0]);

  const memberParam = parameter.member;
  var memberParamString = JSON.stringify(memberParam);

  formData.append("memberParamString", memberParamString);

  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/funeral/join?phone=${memberParam.phone}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

export { requestJoinFuneralApi };
